import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../../hoc/toJS'
import {  FLYER_DEFAULT } from '../../../constants/state'
import { addNewFlyer, printDataUpdateRequest } from '../../../actions'
import EditFlyer from '../../PageEditItem/present/EditFlyer'


const mapStateToProps = state => ({
    itemData: FLYER_DEFAULT
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    onUpdateItem: itemData => {
        dispatch(addNewFlyer(itemData, ownProps.closePagePath))
        dispatch(printDataUpdateRequest())
    }
})

const AddFlyerContainer = ({itemData, onUpdateItem, closePagePath }) => <EditFlyer
    itemData={itemData}
    closePagePath={closePagePath}
    onUpdateItem={onUpdateItem}
/>



export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(AddFlyerContainer)
